import { render, staticRenderFns } from "./tileButton.vue?vue&type=template&id=8aa9cd6a&scoped=true&"
import script from "./tileButton.vue?vue&type=script&lang=js&"
export * from "./tileButton.vue?vue&type=script&lang=js&"
import style0 from "./tileButton.vue?vue&type=style&index=0&id=8aa9cd6a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa9cd6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8aa9cd6a')) {
      api.createRecord('8aa9cd6a', component.options)
    } else {
      api.reload('8aa9cd6a', component.options)
    }
    module.hot.accept("./tileButton.vue?vue&type=template&id=8aa9cd6a&scoped=true&", function () {
      api.rerender('8aa9cd6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ui/tileButton/tileButton.vue"
export default component.exports